import React from 'react'
import {
  Table, TableBody, TableCell, TableContainer,
  TableFooter,
  TableHead, TableRow,
  Tooltip
} from '@mui/material'
import AuthError from '../../../../components/ErrorComponents/AuthError'

const StickyTable = ({ columns = [], rows = [], className = '', testId = '', freezColumns = 0 }: any): JSX.Element => {
  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 20) {
      return (<Tooltip title={text}><span>{`${text}`}</span></Tooltip>)
    }
    return <span>{text}</span>
  }

  return (
    <TableContainer sx={{
      maxWidth: '100%',
      overflowX: 'auto',
      position: 'relative',
      minHeight: rows?.length === 0 ? '250px' : '0px',
      '&::-webkit-scrollbar': {
        height: '8px'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555'
      }
    }} >
      <Table stickyHeader className={className}>
        <TableHead>
          <TableRow>
            {columns?.map((col: any, index: number) => (
              <TableCell
                key={col}
                style={{
                  border: 'none',
                  fontFamily: 'Honeywell Sans Web',
                  position: index < freezColumns ? 'sticky' : 'static',
                  left: index === 0 ? 0 : index === 1 ? 100 : index === 2 ? 250 : undefined,
                  zIndex: index < freezColumns ? 2 : 1,
                  color: '#F0F0F0',
                  backgroundColor: '#3B3B3B',
                  padding: '8px',
                  fontSize: '16px',
                  minWidth: 150
                }}
              >
                <span style={{ width: '65%', display: 'inline-block' }}>{col}</span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody data-testid={testId}>
          {rows?.map((row: any, index: number) => (
            <TableRow key={index} data-testid={testId} >
                {row?.length > 0 && row?.map((text: any, index: number) => (
                    <>
                    <TableCell
                  key={index}
                  style={{
                    border: 'none',
                    fontFamily: 'Honeywell Sans Web',
                    position: index < freezColumns ? 'sticky' : 'static',
                    left: index === 0 ? 0 : index === 1 ? 100 : index === 2 ? 250 : undefined,
                    zIndex: index < freezColumns ? 1 : 0,
                    minWidth: 150,
                    color: '#D0D0D0',
                    backgroundColor: '#3B3B3B',
                    padding: '8px',
                    fontSize: '15px'
                  }}
                >
                  {formatTextWithTooltip(text)}
                </TableCell>
                    </>
                ))}
            </TableRow>
          ))}
          {rows?.length === 0 && (
            <TableRow>
                <TableCell className='nodatarow' style={{
                  border: 'none',
                  fontFamily: 'Honeywell Sans Web',
                  color: '#D0D0D0',
                  backgroundColor: '#3B3B3B',
                  padding: '8px',
                  fontSize: '15px',
                  width: '10%'
                }}
                  colSpan={20} align='center'>
                    <AuthError errorMessage="NoDataPresent" />
                </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
            <TableRow>
                <TableCell
                 style={{
                   border: 'none',
                   height: '20px'
                 }}>

                </TableCell>
            </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default StickyTable
